/**
 * Sticky header settings
 */

import enquire from 'enquire-js';

document.body.classList.add('zansforcans');

// main vars
const body = document.body;
const logoBar = document.querySelector('.site-header__logo-bar');
const topOfHeader = logoBar.offsetTop;

function fixNav() {
	if (window.pageYOffset >= topOfHeader) {
		body.classList.add('fixed-header');
	} else {
		body.classList.remove('fixed-header');
	}
}

function headerClasses() {
	if (window.pageYOffset >= 46) {
		body.classList.add('not-top');
	} else {
		if (body.classList.contains('not-top')) {
			body.classList.remove('not-top');
		}
	}
}

enquire.register('screen and ( max-width: 767px )', {
	match: function() {
		window.addEventListener('scroll', headerClasses);
		window.addEventListener('resize', headerClasses);
	}
});

enquire.register('screen and ( min-width: 768px )', {
	match: function() {
		window.addEventListener('scroll', fixNav);
		window.addEventListener('resize', fixNav);
	}
});

document.addEventListener('DOMContentLoaded', headerClasses);
document.addEventListener('DOMContentLoaded', fixNav);
